/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysLotTransHistory ( props ) {

    const [, setGrid] = useState();


    useEffect(()=> {

            let gridStorageKey = "grid-MomSysVwSgtLotTransLog-data-grid-layout";
            localStorage.removeItem ( gridStorageKey );

    },[])


    const onGridInitialized = (grid) => {

        grid.selectionMode = "None";
        setGrid(grid);
        
    };

    return (

        <BasicCrudScreenType
            id="MomSysVwSgtLotTransLog"
            table="MomSysVwSgtLotTransLog"
            view="MomSysVwSgtLotTransLog"
            noCreate
            noEdit
            noDelete
            noExcel
            onInitialized={onGridInitialized}
        />                                

    );

}

export default MomSysLotTransHistory;
